import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable()
export class CnhService {
  private apiBaseUrl = environment.apiBaseUrl;
  private telemetryCoreUrl = environment.telemetryServiceUrl;
  private isoTaskManagementServiceUrl = environment.isoTaskManagementServiceUrl;
  cnhStatus = 'undefined';

  constructor(private http: HttpClient) {}

  storeCNHAccountData(): Observable<any> {
    return this.http.get<any>(this.telemetryCoreUrl + 'api/providers/set-auth-cookie', {
      withCredentials: true,
    });
  }

  disconnectCNHAccount(externalSource: string, isTelemetry: boolean): Observable<any> {
    return this.http
      .delete(
        this.telemetryCoreUrl +
          'api/providers/revoke-token?externalSource=' +
          externalSource +
          '&telemetry=' +
          isTelemetry
      )
      .pipe(map((response) => console.log('disconnected')));
  }

  clearCNHMetaData(externalSource: string): Observable<any> {
    return this.http
      .delete(
        this.telemetryCoreUrl + 'api/providers/remove-metadata?externalSource=' + externalSource
      )
      .pipe(map((response) => console.log('remove meta data')));
  }

  getCNHAccountStatus(isTelemetry: boolean): Observable<any> {
    return this.http.get<HttpResponse<any>>(
      this.telemetryCoreUrl + 'api/providers/get-auth?telemetry=' + isTelemetry,
      { withCredentials: true, observe: 'response' }
    );
  }

  connectToCNH(externalSource: string, syncMode): Observable<any> {
    let noTaskSync = '';
    if (syncMode == 'GFF') {
      noTaskSync = '&noTaskSync=' + false;
    }
    return this.http.get<any>(
      this.telemetryCoreUrl + 'api/providers/connect?externalSource=' + externalSource,
      { withCredentials: true }
    );
  }

  syncFieldCNH(externalSource: string): Observable<any> {
    return this.http.get<any>(
      this.telemetryCoreUrl + 'api/providers/syncFields?externalSource=' + externalSource,
      { withCredentials: true }
    );
  }

  syncEquipmentCNH(externalSource: string): Observable<any> {
    return this.http.get<any>(
      this.telemetryCoreUrl +
        'api/providers/syncEquipmentFromProvider?externalSource=' +
        externalSource,
      { withCredentials: true }
    );
  }

  syncAllCNH(externalSource: string): Observable<any> {
    return this.http.get<any>(
      this.telemetryCoreUrl + 'api/providers/syncAll?externalSource=' + externalSource,
      { withCredentials: true }
    );
  }

  getEquipmentList(externalSource): Observable<any> {
    return this.http.get<any>(
      this.isoTaskManagementServiceUrl +
        'iso/taskdata/getEquipmentList?externalSource=' +
        externalSource,
      { withCredentials: true }
    );
  }

  sendActivityToCnh(fieldActivityId, externalSource, equipmentId): Observable<any> {
    return this.http.post(
      this.apiBaseUrl +
        'api/private/v3/isoxml/fieldActivity/' +
        fieldActivityId +
        '/send?externalSource=' +
        externalSource +
        '&equipmentId=' +
        equipmentId,
      null
    );
  }

  getStatusSync(externalSource: string): Observable<any> {
    return this.http
      .get<any>(
        this.telemetryCoreUrl + 'api/providers/statusSync?externalSource=' + externalSource,
        { withCredentials: true }
      )
      .pipe(
        map((response) => {
          return {
            body: response,
            status: response.status,
          };
        })
      );
  }
}
